import React, { Component } from "react"
import styled from "styled-components"

import { inject, observer } from "mobx-react"
import Spacer from "~/components/Spacer"

import OrderCard from "./Order"
import RobotOrderCard from "./RobotOrder"

import SignUpForm from "~/components/auth/SignUpForm"
import PaymentInfo from "./Form"

const PageContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 0 2em 0 2em;
  margin: 0 auto;
  background-color: ${(props) => props.theme.colors.background.main};
  ${(props) => props.theme.media.smallDesktop`
  flex-direction: column;
  justify-content: flex-start;
  `}
  ${(props) => props.theme.media.mobile`
  padding: 0 1em 0 1em;
  `}
`

const LeftContainer = styled.div`
  ${(props) => props.theme.media.smallDesktop`
    display: flex;
    flex-direction: column-reverse
    align-items: center;
    justify-content: center;
  `}
`

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 750px;
  ${(props) => props.theme.media.smallDesktop`
    align-items: center;
    justify-content: center;
  `}
`

const SpacerContainer = styled.div`
  ${(props) => props.theme.media.smallDesktop`
    display:none;
  `}
`
@inject((all) => ({
  isPayFlow: all.store.parkingFlow.flow.isPayFlow,
  isRobotPayFlow: all.store.parkingFlow.flow.isRobotPayFlow,
}))
@observer
class ParkingCheckout extends Component {
  render() {
    const { isPayFlow, isRobotPayFlow } = this.props
    return (
      <PageContainer>
        <LeftContainer>
          <SpacerContainer>
            <Spacer desktop={30} />
          </SpacerContainer>
          {isPayFlow && <OrderCard />}
          {!isPayFlow && isRobotPayFlow && <RobotOrderCard />}
        </LeftContainer>
        <Spacer direction="width" desktop={60} mobile={10} />
        <RightContainer>
          <SignUpForm accountRequired={false} />
          <PaymentInfo />
        </RightContainer>
      </PageContainer>
    )
  }
}

export default ParkingCheckout
